import { UserAttributeDefs } from "@iotv/datamodel-core";
import { Position } from "@iotv/iotv-v3-types";
import { EFFLUENT_PATH_TYPE, EffluentPath } from "./EffluentPath";
import { AreaData, DEFAULT_RANGE, EffluentTracker } from "./EffluentTracker";
import { EffluentSpreaderHelper } from "../utilityFns";

const typeName = "TravellingEffluentSpreader";
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;

export class TravellingEffluentSpreader extends EffluentTracker {
  // DeviceEnabledType<SupportedDevices> {
  constructor(ob: any) {
    super(ob);
    this.type = typeName;
  }

  /**
   * Updated relevant runs. Allows runs of type TravellingEffluentSpreader
   * @param runList
   * @returns runs of correct run type
   */
  getRelevantRuns(runList: EffluentPath[]): EffluentPath[] {
    debug && console.log("Using travelling specific - getRelevantRuns");

    return []; // stopping travelling paths

    // let filteredRuns = runList; // runList.filter((run) => run.pathType === EFFLUENT_PATH_TYPE.TravellingEffluentSpreader);
    // return filteredRuns;
  }

  getSpreadOfRawRun(
    relevantRun?: EffluentPath,
    path: Position[] = this.path,
  ): AreaData | undefined {
    debug && console.log("Using TES - getSpreadOfRawRun");

    if (path.length > 1) {
      // linearlize the path
      // const x = path.map((p) => p.lat);
      // const y = path.map((p) => p.lng);
      // let mappedfindLineByLeastSquares(x, y) || path;

      let mapped = this.getPathOnRun(path); //relevantRun should always be undefined
      let turfBoundary = EffluentSpreaderHelper.getLineBoundaries(
        mapped,
        this.throwDistance || DEFAULT_RANGE,
      );
      if (turfBoundary) {
        let positions = EffluentSpreaderHelper.convertTurfToPosition(
          turfBoundary.geometry.coordinates[0],
        );

        let area = EffluentSpreaderHelper.getAreaMeter(turfBoundary);
        return { positions, area };
      }
    }
    return undefined;
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
    };
  }
}
